import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["photos", "targetRowHeight", "rowConstraints"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { resolveCommonProps, unwrapParameter, resolveResponsiveParameter } from "../utils/index.js";

function resolveRowsProps(containerWidth, _ref) {
  var photos = _ref.photos,
      targetRowHeight = _ref.targetRowHeight,
      rowConstraints = _ref.rowConstraints,
      rest = _objectWithoutProperties(_ref, _excluded);

  var _resolveCommonProps = resolveCommonProps(containerWidth, rest),
      spacing = _resolveCommonProps.spacing,
      padding = _resolveCommonProps.padding,
      componentsProps = _resolveCommonProps.componentsProps,
      render = _resolveCommonProps.render;

  var _ref2 = unwrapParameter(rowConstraints, containerWidth) || {},
      singleRowMaxHeight = _ref2.singleRowMaxHeight,
      minPhotos = _ref2.minPhotos,
      maxPhotos = _ref2.maxPhotos;

  if (singleRowMaxHeight !== void 0 && spacing !== void 0 && padding !== void 0) {
    var maxWidth = Math.floor(photos.reduce(function (acc, _ref3) {
      var width = _ref3.width,
          height = _ref3.height;
      return acc + width / height * singleRowMaxHeight - 2 * padding;
    }, padding * photos.length * 2 + spacing * (photos.length - 1)));

    if (maxWidth > 0) {
      componentsProps.container = _objectSpread({}, componentsProps.container);
      componentsProps.container.style = _objectSpread({
        maxWidth: maxWidth
      }, componentsProps.container.style);
    }
  }

  return _objectSpread(_objectSpread({}, rest), {}, {
    targetRowHeight: resolveResponsiveParameter(targetRowHeight, containerWidth, [function (w) {
      return w / 5;
    }, function (w) {
      return w / 4;
    }, function (w) {
      return w / 3;
    }, function (w) {
      return w / 2;
    }]),
    render: render,
    spacing: spacing,
    padding: padding,
    minPhotos: minPhotos,
    maxPhotos: maxPhotos,
    componentsProps: componentsProps
  });
}

export { resolveRowsProps as default };